export class Cnpj {
  private readonly CNPJ_BLACKLIST = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ]

  private readonly FORMATTING_REGEX = /[-\\/.]/g

  private readonly NON_ALPHANUMERIC_REGEX = /[^A-Z0-9]/g

  private readonly ALPHANUMERIC_CNPJ_REGEX = /^[A-Z0-9]{12}\d{2}$/

  private readonly ASCII_ZERO = '0'.codePointAt(0)!

  constructor(private readonly cnpj?: string) {}

  private verifierDigit(digits: string): number {
    let index = 2
    const reverse: number[] = digits
      .toUpperCase()
      .split('')
      .map((character) => Number(character.codePointAt(0)) - this.ASCII_ZERO)
      .reverse()

    const sum: number = reverse.reduce((buffer, number) => {
      buffer += number * index
      index = index === 9 ? 2 : index + 1
      return buffer
    }, 0)

    const mod: number = sum % 11
    return mod < 2 ? 0 : 11 - mod
  }

  private strip(number?: string, strict = false): string {
    const regex: RegExp = strict ? this.NON_ALPHANUMERIC_REGEX : this.FORMATTING_REGEX
    return (number || '').toUpperCase().replace(regex, '')
  }

  format(strict = false): string {
    if (!this.cnpj) return ''
    if (this.cnpj.length < 14) return this.cnpj
    return this.strip(this.cnpj, strict).replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
      '$1.$2.$3/$4-$5',
    )
  }

  removeFormatting(): string {
    return this.strip(this.cnpj, true)
  }

  isEqual(other?: string): boolean {
    return this.removeFormatting() === new Cnpj(other).removeFormatting()
  }

  validate() {
    if (!this.cnpj) return false

    const stripped = this.strip(this.cnpj, true)

    if (!this.ALPHANUMERIC_CNPJ_REGEX.test(stripped)) {
      return false
    }

    if (this.CNPJ_BLACKLIST.includes(stripped)) {
      return false
    }

    let digits = stripped.substring(0, 12)
    digits += this.verifierDigit(digits)
    digits += this.verifierDigit(digits)

    return digits === stripped
  }
}
